export default "__VITE_ASSET__ByHs1W77__"